angular.module('impactx.chiplist', []);